import moment from 'moment'

export default {
  methods: {
    formatDate (date, format) {
      return moment(date).format(format)
    },
    getUserAge (birthdate) {
      return moment().diff(moment(birthdate), 'years')
    },
    timeFrom (date) {
      return moment().to(moment(date))
    }
  }
}
